<template>
  <div class="home">
    <div class="imgbox">
      <!-- 最外层div设置为绝对定位 -->
      <div style="position: absolute;">
        <img class="box-img" src="../assets/banner2.png">
        <div class="box-font">补充公告</div>
      </div>
    </div>
    <article class="newhome" v-cloak style="padding-bottom: 100px;">
      <div style="margin-left: 20px;padding:20px;border: 1px solid #CCCCCC;">
        <h3 style="text-align: center;">{{ detail.Title }}</h3>
        <p style="text-align: center;font-size: 16px;">{{ detail.PublishTime }}</p>
        <div style="padding-top: 30px;" v-html=detail.Content></div>
      </div>
    </article>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: "ResultbcNotice",
  components: {},
  data() {
    return {
      Id: 0,
      detail: "",
      Contact: []
    };
  },
  created() {
    this.Id = this.$route.query.id;
    this.getData();
    //this.getContact();
  },
  methods: {
    getData() {
      var that = this;
      that.$api.get("supplyNotice/" + that.Id, null, r => {
        that.detail = r.response;
      });
    },
    getContact() {
      var that = this;
      that.$api.get("Config/GetGroupList", { groupkey: "Contact" }, r => {
        that.Contact = r.response;
        console.log(that.Contact)
      });
    }
  },
  watch: {
    $route(to) {
      this.getData();
      //this.getContact();
    }
  },
  computed: {

  }
};
</script>

<style>
article.newhome {
  width: 1300px;
}

.el-table .cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

input::-webkit-input-placeholder {
  color: #999999;
  padding: 10px 0px 16px 10px;
}

.pagination {
  text-align: center;
}

.frame-border {
  width: 204px;
  border: 1px solid #EEEEEE;
}

.lmenu {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #222222;
  font-size: 18px;
}

.el-table .cell {
  white-space: normal;
}

.el-form-item {
  margin-bottom: 0px;
}
</style>
